export default {
    getAllSDM18HCLs: () => {
        return {
            url: '/myfhe/SDM18HCLs',
            method: 'GET'
        };
    },
    getOneSDM18HCLDetails: SDM18HCLId => {
        return {
            url: '/myfhe/SDM18HCLs/:SDM18HCLId',
            method: 'GET',
            route_params: {
                SDM18HCLId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/SDM18HCL/api.js